.facility-overview-wrapper{display:flex;gap:10px;flex-wrap:wrap}.description{flex:4;font-weight:400;font-size:16px;font-family:GothamNarrowBook,sans-serif}
/*# sourceMappingURL=facility-overview.component-U22DORHC.css.map */
